import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { endpointsURL } from "../constants/endpointsURL";
import { TokenService } from "../core/services/token.service";

@Injectable({
  providedIn: "root",
})
export class ImportDatosAccesoriosService {
  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService
  ) {}
  env = environment.env;
  importDatosAccesoriosURL = endpointsURL.importDatosAccesorios;

  public getUltimaCargaFichero(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.importDatosAccesoriosURL}`
    );
  }

  public getArchivo(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.importDatosAccesoriosURL}/download`
    );
  }

  public getFile() {
    return this.httpClient.get(
      `${this.env}${this.importDatosAccesoriosURL}/download`,
      {
        responseType: "blob",
      }
    );
  }

  public importArchivo(any: any): Observable<any[]> {
    return this.httpClient.post<any[]>(
      `${this.env}${this.importDatosAccesoriosURL}/import`,
      any
    );
  }

  public importArchivoFrm(datosGroupForm: any): Observable<any[]> {
    const fd = new FormData();
    if (datosGroupForm.value.archivo == null) {
      fd.append("uploadfile", new Blob([], { type: "text/html" }));
    } else {
      fd.append("uploadfile", datosGroupForm.value.archivo);
    }

    fd.append("user", this.tokenService ? this.tokenService.getUserName() : "");
    return this.httpClient.post<any>(
      `${this.env}${this.importDatosAccesoriosURL}/import`,
      fd
    );
  }

  public getRestore(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.importDatosAccesoriosURL}/restore`
    );
  }
}
